<script>
import Label from '../form-components/Label.vue'
import Multiselect from "vue-multiselect";
import * as categoryService from '../../../components/service/category.service';

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        last_updated: {
            type: Object,
            required: false
        },
        selectedItem: {
        type: Object,
        required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label, Multiselect
    },
    data() {
        return {
            value: '',
            options: [],
            d_check: this.selectedItem ? typeof this.selectedItem[this.item.displayOn] != 'string' ? JSON.stringify(this.selectedItem[this.item.displayOn]) == this.item.displayOnValue 
            : this.selectedItem[this.item.displayOn] == this.item.displayOnValue 
            : false        
        };
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.d_check;
            },
            set: function (newValue) {
                this.d_check = newValue;
            }
        }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {    
                    if(typeof val.value != 'string'){
                        this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                    } else {
                        this.display_none_check = val.value == this.item.displayOnValue ? true : false;
                    }                     
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = this.options.filter(x => x.id == val)[0];
            },
            deep: true
        },
        value(val) {
            if(val && val.id) {
                this.updateValue(this.item_key, val.id);
            }
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }
    },
    methods: {
        async getOptions() {
            let filter = {
                "where": {
                "name": "Contact Us",
                "cmsId": this.$route.params.cmsId
                }
            };

            filter = encodeURIComponent(JSON.stringify(filter));
            
            let data = await categoryService.getWithFilter(filter)
            let options = data[0].additionalProp1.questions;
            if(options) {
                this.options = options
                this.options = this.options.filter(x => x.active)
                this.value = this.options.filter(x => x.id == this.item_value)[0]
            } else {
                await this.getOptions()
            }

        }
    },
    async mounted() {
        await this.getOptions();
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <Label :item="item"/>
        <multiselect
            track-by="title"
            label="title"
            v-model="value"
            :options="options"
            :searchable="options.length > 5 ? true : false"
            :close-on-select="true"
            :show-labels="false"
            :placeholder="item.placeholder"
            :allow-empty="true"
            :preselectFirst="true"
        >
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
        </multiselect>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



